import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class LoginValidator {

    login = [
        Validators.required,
        // Validators.pattern('^[^\s@]+@[^\s@]+\.[^\s@]+$')
        // Validators.email
    ];

    password = [
        Validators.required
    ];

    // Error messages
    errorMessages = {
        login: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },
            // {
            //     type: 'pattern', 
            //     message: 'Введен неверный формат e-mail',
            //     options: null
            // },
            // {
            //     type: 'email', 
            //     message: 'MESSAGES.EMAIL_FORMAT',
            //     options: null
            // }
        ],
        password: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}